import { Component, Input,OnInit,AfterViewInit, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { College_Names, collegedetails, CollegeService, UserSet, scoreid, Student_scheduleid } from '../services/College_name.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon'; 
import { MatInputModule } from '@angular/material/input';
import { Router,ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

interface TreeNode {
  name: string;
  children?: TreeNode[];
  open?: boolean;
}

@Component({
  selector: 'manual-evaluation',
  templateUrl: './manual-evaluation.component.html',
  styleUrls: ['./manual-evaluation.component.scss'],
})
export class ManualEvaluationComponent {
  isReady: boolean;
  modalAnswerText: string;
  manualEvaluationsRecords: GridItem[] = [];
  gridDataCopy: GridItem[];
  manualEvaluationsRecords2: any;
  // newData: ConvertedAnswer[];
  student_id: Student_scheduleid;
  @ViewChild("submitEval") submitEval: TemplateRef<any>;

  scheduleid: any;
  id: any;
  questions_ready: boolean;
  scoreDetails = [];
  user_name: any;
  user_id: any;
  College_Name: any;
  total_score: any;
  College_Id: any;
  userScoreMap = new Map<Number, Array<any>>();
  Question_Set_Id: any;
  Year_Id: any;
  ScoreFieldEmptyCheck: boolean = false;
  finalCheck: boolean = false;
  checkArray: any [] = [];
  allFalse: boolean = true;
  isLoading: boolean = true;
  isEvaluated: any;
  isModalOpen: boolean = false;
  
  
  modalRef: any;
  modalRefe: any
  @ViewChild("Validation") modalValidation: TemplateRef<any>;
  @ViewChild("Back") modalBack: TemplateRef<any>;
  fname: string;
  lname: string;
  newCheckArray: any[];
  backCheckArray: any[] = [];
  goBack: boolean;
  goBackFlag: boolean = false;
  goBackToEvalWorkbench: boolean;
  modalReference: any;
  total_score_entered_by_evaluator: number = 0;
  total_computed_score_entered_by_evaluator: number = 0;
  disableButton: boolean;
  isCandidateEvaluated: any;
  userScoreMapNew = new Map<Number, Array<any>>();
  modalQuestionText: string;
 
  // @Input() gridData: GridItem[] = [];
  constructor(  private fs: CollegeService,private domSanitizer: DomSanitizer,private route: ActivatedRoute,private router: Router,private modal: NgbModal) {}

  @ViewChild('videoContainer') videoContainer!: ElementRef<HTMLDivElement>;


  treeData: TreeNode[] = [
    {
      name: 'Section 1',
      children: [
        { name: 'Child 1.1' },
        { name: 'Child 1.2' },
      ],
    },
    
  ];
  answeraudio: any;


  gridData: GridItem[] = [];
  private commentTimeout: any;

  
  ngAfterViewInit() {
   
    this.isReady = true
  }






  ngOnInit(){
    console.log("inside ngoninyt*********",this.route.snapshot.params)

    this.user_name = this.route.snapshot.params.Name;
    this.total_score = this.route.snapshot.params.Total_Score;
    this.user_id = this.route.snapshot.params.User_Id;
    this.College_Name = this.route.snapshot.params.College_Name;
    this.College_Id = this.route.snapshot.params.College_Id;
    this.Question_Set_Id = this.route.snapshot.params.Question_Set_Id;
    this.Year_Id = this.route.snapshot.params.Year_Id;
    this.isEvaluated = this.route.snapshot.params.isEvaluated
    this.isCandidateEvaluated = this.route.snapshot.params.isCandidateEvaluated;
   
    this.fname = sessionStorage.getItem('fname');

    this.lname = sessionStorage.getItem('lname');
    this.isLoading = true;

    if(this.isCandidateEvaluated == "Yes" || this.isEvaluated == "Completed"){
      this.disableButton = true;
    }else{
      this.disableButton = false;
    }
    this.RetriveManualEvalautaionQuestionsFromDB();

    console.log("Year Id",this.Year_Id);
    console.log("Question_SET_Id",this.Question_Set_Id);

    for (var i = 0; i < this.gridData.length; i++) {
      this.gridData[i].ScoreFieldEmptyCheck = false;
    }

    
    
  }

  sanitize(dataurl:string){
    return this.domSanitizer.bypassSecurityTrustUrl(dataurl);
  }

  openModal(questionText : string,answerText: string) {
    console.log("Inside the open Modal func in parent Question : ",questionText);
    console.log("Inside the open Modal func in parent Answer : ",answerText);
    this.modalQuestionText = questionText;
    this.modalAnswerText = answerText;  
    console.log("Modal status",this.isModalOpen);
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }

  onCellEdit(item: GridItem, key: string, event: Event): void {
    console.log("KKKK");
    item[key] = (event.target as HTMLInputElement).innerText.trim();
    const index = this.gridData.findIndex((dataItem) => dataItem.Question_Id === item.Question_Id);
    if (index !== -1) {
      this.gridData[index][key] = item[key];
     
    }
  }


  validateField(item: GridItem): void {
    if (item.Score === "") {
      item.ScoreFieldEmptyCheck = true;
    } else {
      item.ScoreFieldEmptyCheck = false;
    }
  }

  onModalStatusChange(isModalOpen: boolean) {
    this.isModalOpen = isModalOpen;
  }


  onInputChanged(event: Event,target): void {
    console.log("Target",target);
    //const inputElement = event.target as HTMLInputElement;
    let value = target.Score;

    console.log("Printing the value",value);

    // Filter out non-numeric characters
    value = value.replace(/\D/g, '');
console.log("Printing the updated value",value);
    // Update the model with the filtered value
   // this.item.Score = value;
   this.scoreFunction(target)

  }


  
  
  scoreFunction(data){


    // const numericRegex = /^[0-9]*$/;

    // if (!numericRegex.test(data.Score)) {
    //   console.log("Printing the Wrong");
    // }else{
    //   console.log("Printing the Right");
    // }
    
    
    console.log("Printing the incoming Field data : ",data);

    if(data.Complexity_Name ==='Low'){
      console.log("Printing Score",data.Score);
      console.log("Printing the Weightage",data.Low_Weightage);
      data.Computed_Score = data.Low_Weightage * data.Score;
      console.log("Printtt",data.Computed_Score);
    }else if(data.Complexity_Name === "Medium"){
      data.Computed_Score = data.Medium_Weightage * data.Score;
      console.log("Printing the Computed Score ",data.Computed_Score);
    }else if(data.Complexity_Name === "High"){
      data.Computed_Score = data.High_Weightage * data.Score;
      console.log("Printing the Computed Score ",data.Computed_Score);
    }else if(data.Complexity_Name === "Very High"){
      data.Computed_Score = data.Very_High_Weightage * data.Score;
      console.log("Printing the Computed Score ",data.Computed_Score);
    }

    this.calculateTotalScore();
    
    

    

  }



  calculateTotalScore() {
    this.total_score_entered_by_evaluator = 0;
    this.total_computed_score_entered_by_evaluator = 0;
    console.log("Inside calculate score : ",this.total_score_entered_by_evaluator);
    console.log("Printing the grid data ",this.gridData);
    console.log("Printing the check array ",this.checkArray);
    for (var i=0;i<this.gridData.length;i++) {
      if (this.gridData[i].Question_Type_Name !== 'Comprehension With MCQ' &&
      this.gridData[i].Question_Type_Name !== 'Multiple Choice' &&
      this.gridData[i].Question_Type_Name !== 'MCQ With Free Text') {
        const scoreNumber = Number(this.gridData[i].Score);
        this.total_score_entered_by_evaluator  +=  scoreNumber || 0;


        const computedScoreNumber = Number(this.gridData[i].Computed_Score);
        this.total_computed_score_entered_by_evaluator += computedScoreNumber || 0; 
   
      }
    }
 
  }
  
  

  // onCellEditComments(item: GridItem, key: string, event: Event): void {
  //   // Update the item property when the cell is edited
  //   item[key] = (event.target as HTMLInputElement).innerText.trim();
  // }


  onCellEditComments(item: GridItem, key: string, event: Event): void {
    

    console.log("^",item,key,event);
    // Update the item property when the cell is edited
    item[key] = (event.target as HTMLInputElement).textContent.trim();

    console.log("Item.key",item[key]);
  
    // Find the index of the item in the gridData array based on Question Id
    const index = this.gridData.findIndex((dataItem) => dataItem.Question_Id === item.Question_Id);

   // console.log("Indexxxx",index);
  
    // Update the item in the gridData array
    if (index !== -1) {
      this.gridData[index][key] = item[key];
      console.log("P",this.gridData[index][key]);
    }
  }


  

  toggleNode(node: TreeNode): void {
    node.open = !node.open;
  }




   
  

  RetriveManualEvalautaionQuestionsFromDB(){
    console.log("Inside the Retrive manual records function.");
    this.fs.get_Manual_Evaluation_Type_Questions(this.user_id).subscribe(
      (data) => {
  
        console.log("DBB data ",data);
        console.log("data from DB : ",data.results);
        this.manualEvaluationsRecords = data.results;
        
  console.log("@2 ",this.manualEvaluationsRecords);

  // this.gridData.push(this.manualEvaluationsRecords)
  this.gridData = this.gridData.concat(this.manualEvaluationsRecords);
  console.log("Printing the GRID DATA  3 ",this.gridData);

  this.isLoading = false;
      },
      err => {
        console.error(err);
        this.isLoading = false;
      }
  
    );

    

    
  }


 
 

  checkWhetherToGoBack(){
    console.log("Printing the grid data ",this.gridData);
    console.log("Printing the back check array ",this.backCheckArray);
    for(var i=0;i<this.gridData.length;i++){

      if(this.gridData[i].Score == "" || this.gridData[i].Score == null){
        this.gridData[i].goBackFlag = true;
      }else{
        this.gridData[i].goBackFlag = false;
      }

      if (
        this.gridData[i].Question_Type_Name !== 'Comprehension With MCQ' &&
        this.gridData[i].Question_Type_Name !== 'Multiple Choice' &&
        this.gridData[i].Question_Type_Name !== 'MCQ With Free Text'
      ){
        this.backCheckArray.push(this.gridData[i]);
      }
    }

    console.log("Printing the back check array ",this.backCheckArray);
var count = 0;

    for(var i =0;i<this.backCheckArray.length;i++){
      console.log("this.backCheckArray[i].goBackFlag Printing ",this.backCheckArray[i].goBackFlag);

      if(this.backCheckArray[i].goBackFlag != true){
        count = count + 1;
        this.goBackToEvalWorkbench = false;
       
      }else{
        this.goBackToEvalWorkbench = true;
        console.log("No marks have been entered and can go back.....");
      //  this.back();
       
      }
    }

    console.log("************************ COUNT ***********************",count);


    if(count == this.backCheckArray.length){
      console.log("Inside the count equals length");
      this.back();
    }else if(count != 0 && count != this.backCheckArray.length){
      console.log("Some fields have marks entered in them ");
      this.modalReference = this.modal.open(this.modalBack);
      console.log("Printing this.modal Ref ",this.modalRefe);
      console.log("Printing this.modal Ref Back ",this.modalBack);
    }else{
      this.back();
    }

   


    this.backCheckArray = [];
  }

  onModalClose() {
    if (this.modalReference) {
      this.modalReference.dismiss();
    }
  }

  tempSave(){
    this.scoreDetails = [];
    console.log(".......Inside Temp save......");
    // this.SaveDataToDb();

    var createdBy = this.fname + " " + this.lname
    console.log("Printing the gridData before SENDING TO DB ",this.gridData);

    for(var i =0;i<this.gridData.length;i++){
  
      this.userScoreMapNew.set(this.gridData[i].Question_Id , [this.gridData[i].Question_Id,this.gridData[i].Score,this.gridData[i].Computed_Score,this.gridData[i].comments,createdBy]);
    }
    
    console.log("Printing the UserScoreMap ",this.userScoreMapNew);
    
    console.log("******");
    for (let [key, value] of this.userScoreMapNew) {
    
      this.scoreDetails.push(value);
     // console.log(value);
    }
    
    console.log("^^^^^^^^^");
    console.log("ScoreDetails printings ",this.scoreDetails);

    // this.scoreDetails = [];
    // console.log("GGRIDD DATA ",this.gridData);
    // this.convertArray(this.gridData);
    // console.log("New Data ", this.scoreDetails);

    console.log("Printing the testtaker user id",this.gridData[0].Test_Taker_User_Id);
    console.log("Printing the Schedule Id",this.gridData[0].Schedule_Id);
    
  
    
    this.fs.post_Data_To_DB(this.scoreDetails,this.gridData[0].Test_Taker_User_Id,this.gridData[0].Schedule_Id).subscribe(
      (data) => {
        console.log("inside");
        console.log("DB data ", data);
        console.log("data from DB : ", data.results);
        this.manualEvaluationsRecords2 = data.results;
        this.scoreDetails = [];
        
        if (data.code === 200) {
          Swal.fire({
            title: 'Success',
            text: data.success,
            icon: 'success',
            showCancelButton: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              this.total_score = data.results
            //  window.location.reload();
             //this.back();
              return;
            }
          })
        }else if (data.code === 400) {
          Swal.fire({
            title: 'Alert',
            text: data.failed,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              // this.router.navigateByUrl('/test_scheduler');
            }
          })

        }
      },
      (err) => {
        console.error(err);
      }
    );
    console.log("......Temp save completed......")

  }
 
  showWarning(){
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
    this.modalRef = this.modal.open(this.submitEval, ngbModalOptions)
  }
  submitandClose(){
    this.modalRef.close(this.submitEval)

    this.SaveDataToDb();
  }

  SaveDataToDb() {
    this.scoreDetails = [];
    this.allFalse = false;
    var createdBy = this.fname + " " + this.lname


    console.log("Printing the gridData before SENDING TO DB ",this.gridData);

    for(var i =0;i<this.gridData.length;i++){
  
      this.userScoreMap.set(this.gridData[i].Question_Id , [this.gridData[i].Question_Id,this.gridData[i].Score,this.gridData[i].Computed_Score,this.gridData[i].comments,createdBy]);
    }
    
    console.log("Printing the UserScoreMap ",this.userScoreMap);
    
    console.log("******");
    for (let [key, value] of this.userScoreMap) {
    
      this.scoreDetails.push(value);
     // console.log(value);
    }
    
    console.log("^^^^^^^^^");
    console.log("ScoreDetails printings ",this.scoreDetails);

    // this.scoreDetails = [];
    // console.log("GGRIDD DATA ",this.gridData);
    // this.convertArray(this.gridData);
    // console.log("New Data ", this.scoreDetails);

    console.log("Printing the testtaker user id",this.gridData[0].Test_Taker_User_Id);
    console.log("Printing the Schedule Id",this.gridData[0].Schedule_Id);
    
  
    
    this.fs.post_Data_To_DB(this.scoreDetails,this.gridData[0].Test_Taker_User_Id,this.gridData[0].Schedule_Id).subscribe(
      (data) => {
        console.log("inside");
        console.log("DB data ", data);
        console.log("data from DB : ", data.results);
        this.manualEvaluationsRecords2 = data.results;
        this.scoreDetails = [];
        
        if (data.code === 200) {
          Swal.fire({
            title: 'Success',
            text: data.success,
            icon: 'success',
            showCancelButton: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
             // window.location.reload();
             this.back();
              return;
            }
          })
        }else if (data.code === 400) {
          Swal.fire({
            title: 'Alert',
            text: data.failed,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              // this.router.navigateByUrl('/test_scheduler');
            }
          })

        }
      },
      (err) => {
        console.error(err);
      }
    );


    console.log("Printing the test taker id inside the new Save ",this.gridData[0].Test_Taker_User_Id);

    this.fs.post_eval_status_of_candidate_to_DB(this.gridData[0].Test_Taker_User_Id).subscribe(
      (data) => {
        console.log("inside the post eval status of candidate");
        console.log("DB data ", data);
        console.log("Success");
        console.log("data from DB : ", data.results);
      },
      (err) => {
        console.error(err);
      }
    );


   
  }
  

  



  convertArray(inputArray: GridItem[]) {

    console.log("Inside concert array func",inputArray);
    // const convertedArray: ConvertedAnswer[] = [];

    inputArray.forEach((item) => {
      var array = []
      array =   [
        item.Question_Id,
        item.Score,
        item.comments,
        item.Created_By,
      ]
      console.log("array",array)
 
  
      this.scoreDetails.push(array);
      console.log("pushed",this.scoreDetails)

    });
    

    console.log("Converted array printinggggg",this.scoreDetails);
    // return this.scoreDetails;
  }


  back() {
    console.log("isEvaluated",this.isEvaluated)
    const params = {Question_Set_Id:this.Question_Set_Id,College_Id:this.College_Id,Year_Id:this.Year_Id,College_Name:this.College_Name,isEvaluated:this.isEvaluated};
    console.log("Params ",params)
    this.router.navigate(['evaluator_workbench',params]);
  }


  shortlistForInterview(){
    console.log("Printing the test taker user id ",this.user_id);

    this.fs.change_interview_status(this.user_id).subscribe(
      (data) => {
        console.log("inside change interview status");
        
        if (data.code === 200) {
          Swal.fire({
            title: 'Success',
            text: data.success,
            icon: 'success',
            showCancelButton: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
             // window.location.reload();
            //  this.back();
              return;
            }
          })
        }else if (data.code === 400) {
          Swal.fire({
            title: 'Alert',
            text: data.failed,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              // this.router.navigateByUrl('/test_scheduler');
            }
          })

        }
      },
      (err) => {
        console.error(err);
      }
    );


  }

  backToTestEvaluationScreen(){
    this.router.navigate(['test_evaluation']);
  }

};

interface GridItem {
  Very_High_Weightage: number;
  High_Weightage: number;
  Medium_Weightage: any;
  Low_Weightage: any;
  Complexity_Name: string;

  Schedule_Id: Number;
  Question_Id:Number;
  Question_Text:string;
  Question_Type_Id:Number;
  Question_Type_Name:string;
  Answer:string;
  Explanation:string;
  Test_Taker_User_Id:Number;
  Score :string;
  comments:string;
  Created_By:string;
  Score_Id:Number;
  Computed_Score:Number;
  ScoreFieldEmptyCheck:boolean;
  goBackFlag: boolean;
  
  
}









